export default "__VITE_ASSET__BfTW3mpP__"